import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import {SafeDigTask} from '../../Api/SafeDigTaskTypes';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName} from '../../Toolkit/Icons';
import {FluidityTaskTexts} from '../SafeDigConstants';
import TaskEditDialog from '../Dialogs/TaskEditDialog';
import {TaskData} from '../Dialogs/TaskEditDialog';
import {MNullable} from '../../Toolkit/Utils';
import {DataTableSortMeta} from 'primereact/datatable';

type SafeDigTaskRow = {
    data: SafeDigTask;
}

type Props = {
    rowData: object[];
    saveTaskData: (data: TaskData, newEntry: boolean) => void;
    supervisionDate: MNullable<Date>;
    jobComplete: boolean;
}

/** */
type State = {
    filters: MTableFilters;
}

class TaskListControl extends MComponent<Props, State> {

    private readonly m_editRef: RefObject<TaskEditDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_editRef = createRef<TaskEditDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.editTemplate = this.editTemplate.bind(this);
        this.editComplete = this.editComplete.bind(this);
        this.new_Click = this.new_Click.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private edit_Click(lineData: SafeDigTask): void {
        this.m_editRef.current!.show(this.editComplete, {
            taskId: lineData.safeDigTasksId,
            taskSubType: lineData.taskSubType,
            dueDate: lineData.dueDate,
            comment: lineData.comment,
            supervisionDate: this.props.supervisionDate,
            taskComplete: lineData.taskStatus === 2
        });
    }

    private editComplete(data: TaskData): void {
        this.props.saveTaskData(data, data.taskId === -1);
    }

    private new_Click(): void {
        this.m_editRef.current!.show(this.editComplete, {
            taskId: -1,
            taskSubType: 0,
            dueDate: new Date(),
            comment: '',
            supervisionDate: new Date(),
            taskComplete: false
        });
    }

    private taskSubTypeTemplate(rowData: SafeDigTaskRow): string | undefined {
        if(rowData.data.taskType === 1) {
            return FluidityTaskTexts[rowData.data.taskSubType];
        }

        return '';
    }

    private statusTemplate(rowData: SafeDigTaskRow): string | undefined {
        if(rowData.data.taskStatus === 1) {
            return 'Open';
        } else {
            return 'Closed';
        }
    }

    private dueDateTemplate(rowData: SafeDigTaskRow): string | undefined {
        if(rowData.data.dueDate !== null) {
            try {
                return rowData.data.dueDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private completedDateTemplate(rowData: SafeDigTaskRow): string | undefined {
        if(rowData.data.completedDate !== null) {
            try {
                return rowData.data.completedDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private editTemplate(rowData: SafeDigTaskRow): ReactElement {
        return <MButton label={'Edit'}
                        disabled={rowData.data.taskStatus === 2}
                        onClick={this.edit_Click.bind(this, rowData.data)}/>;
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'data.taskStatus', order: 1},
            {field: 'data.taskSubType', order: 1}
        ];
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                <TaskEditDialog ref={this.m_editRef}/>
                <MToolbar>
                    <MButton label="Add Task"
                             icon={MNewIconName}
                             disabled={this.props.jobComplete}
                             onClick={this.new_Click}/>
                </MToolbar>
                <MTable
                    rowKey="data.safeDigTasksId"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()}>

                    <Column field="data.taskSubType"
                            header="Title"
                            body={this.taskSubTypeTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="data.comment"
                            header="Comment"
                            filter={false}
                            sortable={false}
                            style={{width: '55%'}}/>
                    <Column field="data.taskStatus"
                            header="State"
                            body={this.statusTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '10%'}}/>
                    <Column field="data.dueDate"
                            header="Due"
                            body={this.dueDateTemplate}
                            filter={false}
                            sortable={false}
                            style={{width: '10%'}}/>
                    <Column field="data.completedDate"
                            header="Completed"
                            body={this.completedDateTemplate}
                            filter={false}
                            sortable={false}
                            style={{width: '10%'}}/>
                    <Column body={this.editTemplate}
                            filter={false}
                            sortable={false}
                            style={{width: '10%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default TaskListControl;